export default __webpack_public_path__ + "static/media/nft6.375f5310.png";